<script setup lang="ts">
import Section from '../Section.vue';

type PastWork = {
    imgSrc: string;
    clientName: string;
    service: string;
}

const pastWorks: PastWork[] = [
    {
        imgSrc: 'EventLogos/dpg.webp',
        clientName: 'Don\'t Park on the Grass',
        service: 'Event Host / Livestream Graphics Package / Livestream / Level1 Shop'
    },
    {
        imgSrc: 'EventLogos/smashCamp.webp',
        clientName: 'Smash Camp',
        service: 'Event Host / Livestream Graphics Package / Livestream / Level1 Shop'
    },
    {
        imgSrc: 'EventLogos/genesis.webp',
        clientName: 'Genesis',
        service: 'Livestream Graphics Package / Livestream / Level1 Shop'
    },
    {
        imgSrc: 'EventLogos/lacsRivals.webp',
        clientName: 'LACS Rivals',
        service: 'Livestream Graphics Package'
    },
    {
        imgSrc: 'EventLogos/riptide.webp',
        clientName: 'Riptide',
        service: 'Livestream Graphics Package / Livestream'
    },
    {
        imgSrc: 'EventLogos/bobc6.webp',
        clientName: 'Battle of BC',
        service: 'Livestream Graphics Package / Livestream'
    },
    {
        imgSrc: 'EventLogos/eggdogInv.webp',
        clientName: 'Eggdog Invitational',
        service: 'Livestream Graphics Package'
    },
    {
        imgSrc: 'EventLogos/heatwave.webp',
        clientName: 'Heat Wave',
        service: 'Livestream Graphics Package / Livestream / Level1 Shop'
    },
] 
</script>

<template>
    <Section title='Past Works & Clients' id="past-works">
        <div class="client-grid">
            <div v-for="work in pastWorks" class="box">
                <img :src="work.imgSrc" :alt="work.clientName" :title="work.clientName" />
                <div class="label">{{ work.service }}</div>
            </div>
        </div>
    </Section>
</template>

<style lang="scss" scoped>
.client-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(20em, 1fr));
    gap: 1em;
    justify-content: center;

    .box {

        img {
            height: 10em;
            object-fit: contain;
        }

        .label {
            font-style: italic;
        }
    }
}
</style>